import React from 'react';
import { ISelectedOptionChip } from './interfaces';
import { Chip } from '@navi/web-ui/lib/primitives';
import { CloseIcon } from '@navi/web-ui/lib/icons';

const SelectedOptionChip: React.FC<ISelectedOptionChip> = ({
  option,
  onOptionClick,
  wrapperClasses = '',
  labelClasses = '',
  IconColor
}) => {
  const handleChipClose = () => {
    onOptionClick(option);
  };
  return (
    <Chip
      label={option.label}
      onChipClick={e => {
        e?.stopPropagation();
      }}
      RightAdornment={<CloseIcon onClick={handleChipClose} color={IconColor} />}
      wrapperClasses={wrapperClasses}
      labelClasses={labelClasses}
    />
  );
};

export default SelectedOptionChip;
